import { HttpDataService, IHttpDataCache } from '../../../../shared/http/http-data.service';
import { Injectable } from '@angular/core';

export interface ICatalogGuideChoice {
  text:string;
  next?:string;
  orderType?:string;
  products?:string;
}

export enum GuideType {
  ORDER_TYPE,
  SIMPLE
}

export interface ICatalogGuideData {
  type:GuideType;
  text:string;
  choices:ICatalogGuideChoice[];
}

export interface ICatalogGuideMetaConfig {
  [ level:string ]:ICatalogGuideData;
}

@Injectable()
export class CatalogGuideDataService {
  private cache:IHttpDataCache<any>;

  constructor(
    httpDataService:HttpDataService
  ) {
    this.cache = httpDataService.createCache();
  }

  public getConfig(webshopId:number):Promise<ICatalogGuideMetaConfig> {
    return this.cache.doGET(`rest/buyingguide/${webshopId}/config`, undefined, undefined, 'Error loading buying guide');
  }

  public getCodes(webshopId:number):Promise<string[]> {
    return this.cache.doGET(`rest/buyingguide/${webshopId}/codes`, undefined, undefined, 'Error loading buying guide codes');
  }
}
